import { Page } from '@/core/architecture'

import { SerialNumberSelectTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * SerialNumberSelect Page
 * Implemented as a practical sample.
 */
export const SerialNumberSelect: Page = () => {
  const { state, actions } = useViewModel()

  return <SerialNumberSelectTemplate state={state} {...actions} />
}
